import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { AccountService, SessionService } from '../components';
import { ChatQueryParams, TokenResponse } from '../model/chat.model';

@Injectable({
  providedIn: 'root',
})
export class ChatTokenService {
  constructor(
    private http: HttpClient,
    private account: AccountService,
    private currentSession: SessionService
  ) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: 'Bearer ' + this.account.current.token,
      'Voverc-Jwt-Auth': this.account.current.jwtToken,
      'Voverc-Company-ID': String(this.currentSession.current.companyId),
    });
  }

  public getVoxloudChatToken(): Observable<TokenResponse> {
    return this.http.get<TokenResponse>(
      `${environment.API_URL}/api/v1/chat/users/${this.currentSession.current.userId}/token`,
      { headers: this.getHeaders() }
    );
  }

  public getRomulusChatToken(): Observable<TokenResponse> {
    return this.http.get<TokenResponse>(
      `${environment.API_URL}/api/v1/integrations/users/${this.currentSession.current.aggregateId}/token?platform_name=ROMULUS`,
      { headers: this.getHeaders() }
    );
  }

  public getChatTokens(): Observable<ChatQueryParams | null> {
    return forkJoin({
      voxloud: this.getVoxloudChatToken().pipe(catchError(() => of(null))),
      romulus: this.getRomulusChatToken().pipe(catchError(() => of(null))),
    }).pipe(
      map(({ voxloud, romulus }) => {
        if (voxloud?.token) return { token: voxloud.token, provider: 'voxloud' as const };
        if (romulus?.token) return { token: romulus.token, provider: 'romulus' as const };

        return null;
      })
    );
  }
}
